import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import moment from 'moment';
import UserApi from '../../api/users';
import Loading from '../Loading';

const MSDComparison = ({ msds, ...props }) =>
{
    const [msdDetails, setMsdDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [oldMsdId, setOldMsdId] = useState(msds[1]._id);
    const [newMsdId, setNewMsdId] = useState(msds[0]._id);

    const getComparison = async () =>
    {
        try
        {
            setLoading(true);
            const comparison = await UserApi.getMSDComparison(oldMsdId, newMsdId);
            setMsdDetails(comparison);
        } catch (error)
        {
            props.onError(error);
            setMsdDetails({});
        } finally
        {
            setLoading(false);
        }
    }

    useEffect(() =>
    {
        getComparison();
    }, [oldMsdId, newMsdId]);

    const inputContainerStyle = {
        gap: 15
    }
    const container = {
        border: 'solid 1px #E0E0E0',
        boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
        padding: 10,
        marginBottom: 50,
        gap: 15
    }

    const msdComparisonOrder = [
        "PSLF Payments",
        "All Direct Loans",
        "IDR Plan",
        "Servicer",
        "Balance",
        "Min Monthly Payment",
        "IDR Plan Anniversary",
    ];
    return (
        <>
            <div className='d-flex flex-column w-100' style={container}>
                <h4>MSD Comparison</h4>
                <div className="d-flex flex-row" style={inputContainerStyle}>
                    <FormControl className="font-normal">
                        <label>Old MSD:</label>
                        <Select
                            size="small"
                            value={oldMsdId}
                            onChange={(event) => setOldMsdId(event.target.value)}
                        >
                            {
                                msds.map((msd, index) =>
                                {
                                    return <MenuItem key={index} value={msd._id}>{moment(msd.details.request_date, 'X').format('MM/DD/YYYY')}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>


                    <FormControl className="font-normal">
                        <label>New MSD:</label>
                        <Select
                            size="small"
                            value={newMsdId}
                            onChange={(event) => setNewMsdId(event.target.value)}
                        >
                            {
                                msds.map((msd, index) =>
                                {
                                    return <MenuItem key={index} value={msd._id}>{moment(msd.details.request_date, 'X').format('MM/DD/YYYY')}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>

                </div>
                {
                    loading && <Loading message="Loading..." />
                }
                {
                    !loading && <div className="flex flex-row flex-wrap">
                        {Object.keys(msdDetails).sort(
                            (a, b) => msdComparisonOrder.indexOf(a) - msdComparisonOrder.indexOf(b)
                        ).map((key) =>
                            <p style={{ width: '24%', marginRight: 2, marginBottom: 5 }} key={key}><strong>{key}</strong>: {msdDetails[key]}</p>
                        )}
                    </div>
                }
            </div>
        </>
    )
}
export default MSDComparison;
